import { SET_DATA_TYPE_SUPPORTED, SET_SOLUTIONS_OPTIONS, SET_TOOL_SUPPORTED, SET_PATIENTS_DATA, SET_ERROR_DATA, SET_PATIENTS_ERRORS } from "./types";

import { fetchApi, fetchUpload } from "./fetchApi"
import { solutionsOptionsAPI, FETCH_API, UPLOAD_API } from "../env";

export function setSolutionsOptions (data) {
  return {
    type: SET_SOLUTIONS_OPTIONS,
    data
  };
}
export function getSolutionsOptions () {
  return dispatch => {
    return fetchApi(solutionsOptionsAPI)
      .then(res => {
        dispatch(setSolutionsOptions(res));
      });
  };
}
export function setToolSupported (data) {
  return {
    type: SET_TOOL_SUPPORTED,
    data
  };
}

export function setDataTypeSupported (data) {
  return {
    type: SET_DATA_TYPE_SUPPORTED,
    data
  };
}

export function setPatientData (data) {
  return {
    type: SET_PATIENTS_DATA,
    data
  };
}

export function setPatientErrors (data) {
  return {
    type: SET_PATIENTS_ERRORS,
    data
  };
}

export function setErrorData (data) {
  return {
    type: SET_ERROR_DATA,
    data
  };
}

export function getPatientData (startDate, endDate, filters, page=1) {
  var params = {}

  if (startDate) { filters.start_date = new Date(startDate).getTime() / 1000 }

  if (endDate) { filters.end_date = new Date(endDate).getTime() / 1000 }

  return dispatch => {
    return fetchApi(FETCH_API + 'list-patient-records' + "?page="+page, "POST", JSON.stringify(filters), new Headers({
      Accept: 'application/json',
      'Content-Type': 'application/json',
    }))
      .then(res => {
        dispatch(setPatientData(res))
      });
  };
}
export function getPatientErrors (startDate, endDate, filters, page) {
  var params = {}
  page = page || 1;

  if (startDate) { filters.start_date = new Date(startDate).getTime() / 1000 }

  if (endDate) { filters.end_date = new Date(endDate).getTime() / 1000 }

  // if(lowRisk)
  //   params["low"] = lowRisk;

  // if(highRisk)
  //   params["high"] = highRisk;

  // if(ytg)
  //   params["ytg"] = ytg;

  // params = {...riskFilters}
  // JSON.stringify

  return dispatch => {
    return fetchApi(FETCH_API + 'list-patient-errors' + "?page="+ page, "POST", JSON.stringify(filters), new Headers({
      Accept: 'application/json',
      'Content-Type': 'application/json',
    }))
      .then(res => {
        dispatch(setPatientErrors(res))
      });
  };
}

export function getErrorData (page) {
  page = page || 1;
  return dispatch => {
    return fetchApi(FETCH_API + 'get-uploaded-files' + "?page=" + page, "GET")
      .then(res => {
        dispatch(setErrorData(res))
      });
  };
}

export function uploadFile (notificationFile, comorbidityFile) {
  var formdata = new FormData();
  formdata.append("original_notification_file", notificationFile)
  formdata.append("original_comorbidity_file", comorbidityFile)
  return dispatch => {
    return fetchUpload(UPLOAD_API, "POST", formdata)
      .then();
  };
}
